import {
  BulkMessageSenderTypeEnum,
  Student,
  User,
} from "@/__generated__/types";
import { NameAndAvatar } from "@/components/StudentListWrapper/Grid/NameAndAvatar";
import { useLocale } from "@/hooks/useLocale";
import React from "react";
import { useTranslation } from "react-i18next";

export interface BulkMessageAvatarCellProps {
  users: User[] | Student[];
  senderType?: BulkMessageSenderTypeEnum;
  totalCount?: number;
}
export const BulkMessageAvatarCell = ({
  users,
  senderType,
  totalCount,
}: BulkMessageAvatarCellProps) => {
  const locale = useLocale();
  const { t } = useTranslation();
  return (
    <>
      {!totalCount && users[0] && (
        <NameAndAvatar
          firstName={
            senderType === BulkMessageSenderTypeEnum.AssignedCounselor
              ? t("bulkMessaging.table.assignedCounselor")
              : users[0].firstName
          }
          lastName={
            senderType === BulkMessageSenderTypeEnum.AssignedCounselor
              ? ""
              : users[0].lastName
          }
          imageUrl={{ url: users[0].profilePhoto?.url ?? "" }}
        />
      )}
      {totalCount && users[0] && (
        <div className="flex">
          {users.map((user, index) => {
            const { url } = user.profilePhoto ?? {};
            return (
              <div
                key={user.id + url + user.firstName + user.lastName + index}
                className="relative -m-[6px]"
              >
                <NameAndAvatar
                  imageUrl={{ url: url ?? "" }}
                  alt={`${user.firstName} ${user.lastName}`}
                />
              </div>
            );
          })}
          {totalCount && users.length < totalCount && (
            <div className="relative ml-[6px]">
              <p className="ml-1 text-sm font-medium text-foreground">
                +
                {new Intl.NumberFormat(locale).format(
                  Number(totalCount) - users.length,
                )}
              </p>
            </div>
          )}
        </div>
      )}
    </>
  );
};
